import React from 'react';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Row, CardHeader, Input } from 'reactstrap'
import { connect } from 'react-redux';
import {
    fetchMonitoringListRequest, initiateMonitoringRequest, stopMonitoringRequest,
    uploadMonitoringTemplateRequest, downloadMonitoringScoreCalcultionTemplateRequest, publishMonitoringReportRequest
} from "./action";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Preloading as preloading } from '../../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import { displaySuccessMessage, displayErrorMessage } from "./charts/monitoring-util"
const mcaDropDownValueCheck = "mca";
const epfDropDownValueCheck = "epf";
const gstDropDownValueCheck = "gst";
const legalDropDownValueCheck = "legal";
const ratingDropDownValueCheck = "rating";
const defaultMonitoringPeriodDropDownSelection = { label: "Yearly", value: "Yearly" };
const monitoringtypeDict = [{ label: "Monthly", value: "Monthly" }, { label: "Quarterly", value: "Quarterly" }, { label: "HalfYearly", value: "HalfYearly" }, { label: "Yearly", value: "Yearly" }];
class MonitoringInitiation extends React.Component {

    state = {
        selectedOption : undefined,
        monitoringPeriod : [],
        monitoringPeriodList : [],
        ongoingMonitoring : undefined,
        scoreTemplateFile : undefined,
        templateSelectedOption : undefined,
        reportSelectedOption : undefined,
        isPublish : undefined,
        gstDropDownSelected : undefined,
        mcaDropDownSelected : undefined,
        epfDropDownSelected : undefined,
        ratingDropDownSelected : undefined,
        legalDropDownSelected : undefined
    }

    componentDidMount() {
        this.props.fetchMonitoringListRequest();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.publishReportData !== this.props.publishReportData) {
            this.props.preloading(false);
            if (this.props.publishReportData.status === "SUCCESS") {
                displaySuccessMessage(this.state.isPublish ? "Monitoring Report UnPublished !" : "Monitoring Report Published !");
                this.props.fetchMonitoringListRequest();
                this.props.preloading(true);
            } else {
                displayErrorMessage("Please Try again !!");
            }
        }
        if (this.props.monitoringScoreCalculationTemplate !== prevProps.monitoringScoreCalculationTemplate) {
            this.props.preloading(false);
            if (this.props.monitoringScoreCalculationTemplate.status === "SUCCESS") {
                const data = this.props.monitoringScoreCalculationTemplate.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"monitoring_score_template"}_${this.state.templateSelectedOption.label}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.monitoringCounterpartyData.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }
        if (this.props.templateUpload !== prevProps.templateUpload) {
            this.props.preloading(false);
            if (this.props.templateUpload.status === "SUCCESS") {
                this.props.fetchMonitoringListRequest();
                this.props.preloading(true);
                displaySuccessMessage("Template Uploaded Successfully !");
                this.setState({ monitoringTemplateFile: undefined });
            } else {
                let message = this.props.templateUpload.data.message ? this.props.templateUpload.data.message : this.props.templateUpload.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.initiateMonitoringResponse !== prevProps.initiateMonitoringResponse) {
            this.props.preloading(false);
            if (this.props.initiateMonitoringResponse.status === "SUCCESS") {
                this.props.preloading(true);
                this.props.fetchMonitoringListRequest();
                displaySuccessMessage("Monitoring Initiated Successfully !");
            } else {
                displayErrorMessage(this.props.initiateMonitoringResponse.data);
            }
        }

        if (this.props.stopMonitoringResponse !== prevProps.stopMonitoringResponse) {
            this.props.preloading(false);
            if (this.props.stopMonitoringResponse.status === "SUCCESS") {
                this.props.preloading(true);
                this.props.fetchMonitoringListRequest();
                displaySuccessMessage("Monitoring Stopped Successfully !");
            } else {
                let message = this.props.stopMonitoringResponse.data != undefined ? this.props.stopMonitoringResponse.data : "Error stopping QMR";
                displayErrorMessage(message);
            }
        }

        if (this.props.monitoringList !== prevProps.monitoringList) {
            this.props.preloading(false);
            let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.active === true) : [];
            if (arr && arr.length > 0) {
                this.setState({ ongoingMonitoring: arr[0] })
            } else {
                this.setState({ ongoingMonitoring: undefined })
            }
            let monitoringNameOptions = [];
            let period = [];
            this.props.monitoringList && this.props.monitoringList.length > 0 &&
                this.props.monitoringList.forEach(monitoringObj => {
                    monitoringNameOptions = [
                        ...monitoringNameOptions, {
                            value: monitoringObj.id, label: monitoringObj.monitoringName
                        }
                    ]
                        period = [
                            ...period, {
                                monitoringId: monitoringObj.id, monitoringName: monitoringObj.monitoringName, mcaPeriod: monitoringObj.mcaPeriod, gstPeriod: monitoringObj.gstPeriod, epfPeriod: monitoringObj.epfPeriod, legalPeriod: monitoringObj.legalPeriod, ratingPeriod: monitoringObj.ratingPeriod
                            }
                        ]
        })
            let selectedOption = monitoringNameOptions.length > 0 ? monitoringNameOptions[0] : undefined;
            if (selectedOption) {
                let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.id === selectedOption.value) : [];
                if (arr && arr.length > 0) {
                    this.setState({ isPublish: arr[0].publish });
                }
            }
            this.setState({ templateSelectedOption: selectedOption, monitoringPeriod: monitoringNameOptions, selectedOption: selectedOption, reportSelectedOption: selectedOption })
            if (period.length > 0) {
                let tempmcaPeriod;
                if (period[0].mcaPeriod !== null) {
                    tempmcaPeriod = { label: period[0].mcaPeriod, value: period[0].mcaPeriod };
                }
                else {
                    tempmcaPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ mcaDropDownSelected: tempmcaPeriod });

                let tempgstPeriod;
                if (period[0].gstPeriod !== null) {
                    tempgstPeriod = { label: period[0].gstPeriod, value: period[0].gstPeriod };
                }
                else {
                    tempgstPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ gstDropDownSelected: tempgstPeriod });

                let tempepfPeriod;
                if (period[0].epfPeriod !== null) {
                    tempepfPeriod = { label: period[0].epfPeriod, value: period[0].epfPeriod };
                }
                else {
                    tempepfPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ epfDropDownSelected: tempepfPeriod });

                let tempratingPeriod;
                if (period[0].ratingPeriod !== null) {
                    tempratingPeriod = { label: period[0].ratingPeriod, value: period[0].ratingPeriod };
                }
                else {
                    tempratingPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ ratingDropDownSelected: tempratingPeriod });

                let templegalPeriod;
                if (period[0].legalPeriod !== null) {
                    templegalPeriod = { label: period[0].legalPeriod, value: period[0].legalPeriod };
                }
                else {
                    templegalPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ legalDropDownSelected: templegalPeriod });
            }
            this.setState({ monitoringPeriodList: period });
        }
    }
    handleOnChangeFlag = (propertyName, option) => {
        if (propertyName === mcaDropDownValueCheck) {
            this.setState({ mcaDropDownSelected: option })
        }
        if (propertyName === gstDropDownValueCheck) {
            this.setState({ gstDropDownSelected: option })
        }
        if (propertyName === epfDropDownValueCheck) {
            this.setState({ epfDropDownSelected: option })
        }
        if (propertyName === ratingDropDownValueCheck) {
            this.setState({ ratingDropDownSelected: option })
        }
        if (propertyName === legalDropDownValueCheck) {
            this.setState({ legalDropDownSelected: option })
        }
    }

    sendStartRequest = (e) => {
        e.preventDefault();
        let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.id === this.state.selectedOption.value) : [];
        if (arr && arr.length > 0 && (!arr[0].templateId || arr[0].templateId.trim().length == 0)) {
            displayErrorMessage(`Please upload Score calculation template for selected monitoring !`);
        } else if (!this.state.ongoingMonitoring && arr && arr.length > 0 && arr[0].active == false) {
            this.props.initiateMonitoringRequest({ monitoringId: this.state.selectedOption.value });
            this.props.preloading(true);
        } else {
            let message = `Monitoring ${this.state.ongoingMonitoring && this.state.ongoingMonitoring.monitoringName ? this.state.ongoingMonitoring.monitoringName : "is"} already running, first stop then restart!`;
            displayErrorMessage(message);
        }
    }

    sendStopRequest = (e) => {
        e.preventDefault();
        let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.id === this.state.selectedOption.value) : [];
        if (this.state.ongoingMonitoring && this.state.ongoingMonitoring.id === this.state.selectedOption.value && arr && arr.length > 0 && arr[0].active == true) {
            this.props.stopMonitoringRequest({ monitoringId: this.state.selectedOption.value })
            this.props.preloading(true);
        } else {
            let message = `${this.state.ongoingMonitoring && this.state.ongoingMonitoring.monitoringName ? this.state.ongoingMonitoring.monitoringName + " monitoring is running" : " Selected monitoring is not running"} `;
            displayErrorMessage(message);
        }
    }

    handleChange = selectedOption => {
        this.setState({ selectedOption: selectedOption });
    };

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({ scoreTemplateFile: file });
        } else {
            this.setState({ scoreTemplateFile: undefined });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
        e.target = null;
    }

    handleDownloadTemplate = (e) => {
        e.preventDefault();
        let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.id === this.state.templateSelectedOption.value) : [];
        if (arr && arr.length > 0 && (!arr[0].templateId || arr[0].templateId.trim().length == 0)) {
            let message = `Score calculation template not uploaded for ${this.state.templateSelectedOption.label} !`;
            displayErrorMessage(message);
        } else {
            this.props.preloading(true);
            this.props.downloadMonitoringScoreCalcultionTemplateRequest({ monitoringId: this.state.templateSelectedOption.value });
        }
    }

    handleTemplateDropdown = (templateSelectedOption) => {
        this.setState({ templateSelectedOption: templateSelectedOption });
        console.log(templateSelectedOption);
        this.props.preloading(true);
        var i;
        for (i = 0; i < this.state.monitoringPeriodList.length; i++) {
            if (this.state.monitoringPeriodList[i].monitoringId === templateSelectedOption.value) {
                let tempmcaPeriod;
                if (this.state.monitoringPeriodList[i].mcaPeriod !== null) {
                    tempmcaPeriod = { label: this.state.monitoringPeriodList[i].mcaPeriod, value: this.state.monitoringPeriodList[i].mcaPeriod };
                }
                else {
                    tempmcaPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ mcaDropDownSelected: tempmcaPeriod });

                let tempgstPeriod;
                if (this.state.monitoringPeriodList[i].gstPeriod !== null) {
                    tempgstPeriod = { label: this.state.monitoringPeriodList[i].gstPeriod, value: this.state.monitoringPeriodList[i].gstPeriod };
                }
                else {
                    tempgstPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ gstDropDownSelected: tempgstPeriod });

                let tempepfPeriod;
                if (this.state.monitoringPeriodList[i].epfPeriod !== null) {
                    tempepfPeriod = { label: this.state.monitoringPeriodList[i].epfPeriod, value: this.state.monitoringPeriodList[i].epfPeriod };
                }
                else {
                    tempepfPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ epfDropDownSelected: tempepfPeriod });

                let tempratingPeriod;
                if (this.state.monitoringPeriodList[i].ratingPeriod !== null) {
                    tempratingPeriod = { label: this.state.monitoringPeriodList[i].ratingPeriod, value: this.state.monitoringPeriodList[i].ratingPeriod };
                }
                else {
                    tempratingPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ ratingDropDownSelected: tempratingPeriod });

                let templegalPeriod;
                if (this.state.monitoringPeriodList[i].legalPeriod !== null) {
                    templegalPeriod = { label: this.state.monitoringPeriodList[i].legalPeriod, value: this.state.monitoringPeriodList[i].legalPeriod };
                }
                else {
                    templegalPeriod = defaultMonitoringPeriodDropDownSelection;
                }
                this.setState({ legalDropDownSelected: templegalPeriod });
            }
        }
        this.props.preloading(false);
    }

    handleUploadTemplate = (e) => {
        e.preventDefault();
        this.props.uploadMonitoringTemplateRequest({
            file: this.state.scoreTemplateFile,
            monitoringId: this.state.templateSelectedOption.value,
            gstDropDownValue: this.state.gstDropDownSelected.value,
            mcaDropDownValue: this.state.mcaDropDownSelected.value,
            epfDropDownValue: this.state.epfDropDownSelected.value,
            ratingDropDownValue: this.state.ratingDropDownSelected.value,
            legalDropDownValue: this.state.legalDropDownSelected.value
        })
        this.props.preloading(true);
    }

    handlePublishReportDropdown = (reportSelectedOption) => {
        this.setState({ reportSelectedOption: reportSelectedOption }, () => {
            let arr = this.props.monitoringList && this.props.monitoringList.length > 0 ? this.props.monitoringList.filter(obj => obj.id === this.state.reportSelectedOption.value) : [];
            if (arr && arr.length > 0) {
                this.setState({ isPublish: arr[0].publish });
            }
        })
    }

    handlePublishReport = (e) => {
        e.preventDefault();
        this.props.preloading(true);
        this.props.publishMonitoringReportRequest({ monitoringId: this.state.reportSelectedOption.value, publishReport: this.state.isPublish ? "N" : "Y" });
    }

    render() {
        return (
            <Col>
                <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>Monitoring Name </Label>
                                <Col sm={6}>
                                    <Select
                                        value={this.state.selectedOption}
                                        onChange={this.handleChange}
                                        options={this.state.monitoringPeriod} />
                                </Col>
                                <Col sm={4}>
                                    <Button color="primary" onClick={e => this.sendStartRequest(e)}>Start Monitoring</Button>
                                </Col>
                                <Col sm={3}>
                                    <Button color="primary" onClick={e => this.sendStopRequest(e)}>Stop Monitoring</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>

                <Card>
                    <CardHeader className="text-center" > Upload/Download Score Calculation Template</CardHeader>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>Monitoring Name </Label>
                                <Col sm={6}>
                                    <Select
                                        value={this.state.templateSelectedOption}
                                        onChange={this.handleTemplateDropdown}
                                        options={this.state.monitoringPeriod} />
                                </Col>
                                <Col >
                                    <Button color="primary" onClick={e => this.handleDownloadTemplate(e)} disabled={false}>Download Score Calculation Template</Button>
                                </Col>
                            </FormGroup>
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={1}>MCA </Label>
                                <Col sm={4}>
                                    <Select
                                        value={this.state.mcaDropDownSelected}
                                        onChange={(e) => this.handleOnChangeFlag(mcaDropDownValueCheck, e)}
                                        options={monitoringtypeDict}

                                    />
                                </Col>
                                <Label sm={1}>GST </Label>
                                <Col sm={4}>
                                    <Select
                                        value={this.state.gstDropDownSelected}
                                        onChange={(e) => this.handleOnChangeFlag(gstDropDownValueCheck, e)}
                                        options={monitoringtypeDict} />
                                </Col>
                                <Label sm={1}>EPF </Label>
                                <Col sm={4}>
                                    <Select
                                        value={this.state.epfDropDownSelected}
                                        onChange={(e) => this.handleOnChangeFlag(epfDropDownValueCheck, e)}
                                        options={monitoringtypeDict} />
                                </Col>
                            </FormGroup>
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={1.5}>Rating </Label>
                                <Col sm={4}>
                                    <Select
                                        value={this.state.ratingDropDownSelected}
                                        onChange={(e) => this.handleOnChangeFlag(ratingDropDownValueCheck, e)}
                                        options={monitoringtypeDict} />
                                </Col>
                                <Label sm={1.5}>Legal </Label>
                                <Col sm={4}>
                                    <Select
                                        value={this.state.legalDropDownSelected}
                                        onChange={(e) => this.handleOnChangeFlag(legalDropDownValueCheck, e)}
                                        options={monitoringtypeDict} />
                                </Col>
                                {/* <Col >
                                    <Button color="secondary" color="primary" onClick={e => this.submitDataToServer(e)} disabled={false}>Update Monitoring Flags</Button>
                            </Col> */}
                            </FormGroup>

                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Col sm={10}>
                                    <Input type="file" name="monitoring-template-file" id="monitoring-template-file" onChange={(e) => this.uploadFile(e)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                                </Col>
                                <Col >
                                    <Button color="primary" disabled={!this.state.scoreTemplateFile} onClick={e => this.handleUploadTemplate(e)}>Upload Score Calculation Template</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>

                <Card>
                    <CardHeader className="text-center" > Publish/Unpublish Monitoring Report</CardHeader>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>Monitoring Name </Label>
                                <Col sm={6}>
                                    <Select
                                        value={this.state.reportSelectedOption}
                                        onChange={this.handlePublishReportDropdown}
                                        options={this.state.monitoringPeriod} />
                                </Col>
                                <Col >
                                    <Button color="primary" onClick={e => this.handlePublishReport(e)}> {this.state.isPublish ? "Unpublish Report" : "Publish Report"}</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    initiateMonitoringResponse: state.monitoringData.initiateMonitoring,
    stopMonitoringResponse: state.monitoringData.stopMonitoring,
    monitoringList: state.monitoringData.monitoringList,
    templateUpload: state.monitoringData.templateUpload,
    monitoringScoreCalculationTemplate: state.monitoringData.monitoringScoreCalculationTemplate,
    publishReportData: state.monitoringData.publishReportData
})

const mapDispatchToProps = (dispatch) => ({
    initiateMonitoringRequest: (data) => { dispatch(initiateMonitoringRequest(data)) },
    stopMonitoringRequest: (data) => { dispatch(stopMonitoringRequest(data)) },
    fetchMonitoringListRequest: (data) => { dispatch(fetchMonitoringListRequest(data)) },
    uploadMonitoringTemplateRequest: (data) => { dispatch(uploadMonitoringTemplateRequest(data)) },
    preloading: data => { dispatch(preloading(data)) },
    downloadMonitoringScoreCalcultionTemplateRequest: data => { dispatch(downloadMonitoringScoreCalcultionTemplateRequest(data)) },
    publishMonitoringReportRequest: (data) => { dispatch(publishMonitoringReportRequest(data)) },
});


export default connect(mapStateToProps, mapDispatchToProps)(MonitoringInitiation);